import { create } from "zustand";
import { getData, apiHeader } from "../helpers/ApiHelper";

export const useContactStore = create((set, get) => ({
  contactList: [],
  contactLoaded: false,
  contactLoading: false,
  setContactList: (contacts) => set({ contactList: contacts }),
  fetchContactList: async () => {
    const { contactLoaded, contactLoading } = get();
    if (contactLoaded || contactLoading) return;
    try {
      set({ contactLoading: true });
      const response = await getData("contactus/list", {}, apiHeader(false));
      if (
        String(response?.status) === "200" &&
        String(response?.data?.status) === "200"
      ) {
        const contacts = response.data.data.list || [];
        set({ contactList: contacts, contactLoaded: true });
      }
    } catch (e) {
      // silent — consumers can retry via fetchContactList if needed
    } finally {
      set({ contactLoading: false });
    }
  },
}));
